const objToJson = (obj: object | null | undefined) => {
  try {
    if (!obj) return null;
    return JSON.stringify(obj);
  } catch (err) {
    console.log("ERR: ", err);
    return null;
  }
};
const jsonToObj = (json: string | null | undefined) => {
  try {
    if (!json) return null;
    return JSON.parse(json);
  } catch (err) {
    console.log("ERR: ", err);
    return null;
  }
};

const encodeObjURI = (obj: object | null | undefined) => {
  try {
    const json = objToJson(obj);
    if (!json) throw Error("Failed 'objToJson' at 'encodeObjURI'");
    return encodeURIComponent(json);
  } catch (err) {
    console.log("ERR: ", err);
    return null;
  }
};

const decodeObjURI = (uri: string | null | undefined) => {
  try {
    if (!uri) return null;
    return decodeURIComponent(uri);
  } catch (err) {
    console.log("ERR: ", err);
    return null;
  }
};

const ObjectProcessor = {
  objToJson,
  encodeObjURI,
  jsonToObj,
  decodeObjURI
};

export default ObjectProcessor;
